type ImageValidationErrorType = 'URL' | 'FORMAT' | 'DIMENSIONS-SMALL' | 'SIZE-LARGE' | 'OTHER';

export class UploadProductImageError {
  constructor(
    public message: string,
    public status: number,
    public type: ImageValidationErrorType,
    public args?: Record<string, string | number>
  ) {}
}
